import(/* webpackMode: "eager" */ "/vercel/path0/app/(landing-page)/error.tsx");
